export default __webpack_public_path__ + "static/media/logo_pims.03619025.svg";